<template>
  <div class="platform-info-edit-wrp ft-12">
    <el-form class="form" :model="self_form" :rules="rules" ref="form" label-width="12%">
      <section>
        <div class="title ft-12">
          <span>商品分类</span>
        </div>
        <div class="conf">
          <el-form-item label="商品分类：" prop="categoryIds">
            <div class="category ft-12">
              <category-input ref="cinput" v-model="self_form.categoryIds" :platform="platform" :isSupportAi="true" :baseItemId="baseItemId" @change="categoryChange" />
            </div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>基础信息</span>
        </div>
        <div class="conf">
          <el-form-item label="商品名称" prop="productName">
            <el-input type="text" placeholder="请输入商品名称" v-model="self_form.productName" :maxlength="500" show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item label="英文名称" prop="productEnName">
            <el-input type="text" placeholder="仅支持英文字符" v-model="self_form.productEnName" :maxlength="500" show-word-limit>
              <el-tooltip slot="append" effect="dark" content="把单词首字母转为大写(点击生效)" placement="top">
                  <el-button @click="firstLetter(self_form.productEnName)">首字母大写</el-button>
              </el-tooltip>
            </el-input>
          </el-form-item>
          <el-form-item label="商品产地" prop="productWhExtAttrVo">
            <el-select
              v-model="self_form.productWhExtAttrVo.productOrigin.region1ShortName"
              filterable
              clearable
              @change="regionChange"
            >
              <el-option v-for="op in countryCodes" :key="op.code" :value="op.code" :label="op.name"></el-option>
            </el-select>
            <el-select
              v-if="self_form.productWhExtAttrVo.productOrigin.region1ShortName === 'CN'"
              v-model="self_form.productWhExtAttrVo.productOrigin.region2Id"
              filterable
              clearable
              placeholder="请选择省份"
              style="margin-left: 10px"
            >
              <el-option v-for="op in regionIdOpts" :key="op.value" :value="op.value" :label="op.label"></el-option>
            </el-select>
            <div class="flex" 
              v-show="self_form.productWhExtAttrVo.productOrigin.region1ShortName && self_form.productWhExtAttrVo.productOrigin.region1ShortName !== 'CN'" 
              style="font-size:12px;color:#606266;"
            >产地证明（选填）: 
              <el-upload
                class="product-origin-upload-btn"
                action="#"
                accept=".jpg,.jpeg,.png,.pdf"
                :limit="1"
                :file-list="productOriginFileList"
                :auto-upload="false"
                :on-preview="productOriginPreview"
                :on-change="productOriginFileChange"
                :on-remove="productOriginFileRemove"
              >
                  <el-link :underline="false" v-if="!productOriginImg">上传文件</el-link>
              </el-upload>
              <span class="ml-5">单张单张≤3MB，支持pdf、png、jpeg、jpg</span>
            </div>
          </el-form-item>
          <el-form-item v-if="categoryId && !!brandProp" label="品牌" prop="shopBrandConf">
            <ShopBrands
              ref="ShopBrandsRef"
              :categoryId="categoryId"
              :baseItemId="baseItemId"
              :brandProp="brandProp"
              v-model="self_form.shopBrandConf"
              :shopList="shopList"
              filterable
              remote
            />
          </el-form-item>
          <el-form-item label="商品属性" prop="productProperty">
            <CategoryProps
              ref="catepropsRef"
              v-model="self_form.productProperty"
              :initAttrData="initAttrData"
              :categoryId="categoryId"
              :categoryProperties="categoryProperties"
              @switchShop="switchShopHandle"
            />
          </el-form-item>
          <!-- <el-form-item label="素材语言" prop="sourceLanguage">
            <div slot="label">
              素材语言
              <el-tooltip class="item" effect="dark" content="图片包含文字卖点或商品说明，建议勾选多语言素材上传，让商品描述精准适配目标市场语言。提升购买意愿。" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
            <el-checkbox-group v-model="self_form.sourceLanguage">
              <el-checkbox v-for="s in sourceLanguageList" :label="s.value" :disabled="s.value === 'en'" :key="s.value">{{s.label}}</el-checkbox>
            </el-checkbox-group>
            <div style="font-size:12px;color:#ccc;">英语默认勾选；勾选多语种后，轮播图/SKU预览图/详情图文需上传对应语种素材</div>
          </el-form-item> -->
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>图文信息</span>
        </div>
        <div class="conf">
          <!-- <el-form-item label="引用套图:" v-if="showGroupImages">
            <div class="ft-12">
              商品资料已维护套图，电商平台图片可以使用已维护套图快速填充 <el-link @click="editGroupImages">维护套图</el-link>
            </div>
            <GroupImagesList
              :baseItemId="baseItemId"
              @useOk="useGroupImages"
              :specifications="specifications"
              @getList="getGroupImagesList"
            ></GroupImagesList>
          </el-form-item> -->
          <el-form-item label="商品轮播图" v-if="self_form.catType != 1">
            <CarouselImages
              style="background: #f9f9fa"
              ref="carouselImagesRef"
              v-model="self_form.carouselImage"
              :languages="languages"
              :initCarouselImage="initCarouselImage"
              :languageMap="LANGUAGE_MAP"
              :imgLimits="carouselImagesLimits"
            />
            <div class="tips">5-10张；比例1:1，宽>800px，高>800px；</div>
          </el-form-item>
          <!-- <el-form-item label="详情图文">
              <el-tabs v-model="detailType">
                <el-tab-pane v-for="k in languages" :label="LANGUAGE_MAP[k]" :name="k" :key="k">
                    <Editor :id="k" :limitImgSize="3 * 1024 * 1024" v-model="self_form.goodsLayerDecoration" placeholder="请输入" @fullScreenChange="editorFullScreenChange" />
                </el-tab-pane>
              </el-tabs>
              <div class="tips">图片宽高比 1/2≤x≤2，宽度≥480px，大小≤3M</div>
          </el-form-item> -->
          <el-form-item label="图文详情" prop="goodsLayerDecoration">
            <div class="imgs-wrp">
              <div class="ft-12">
                <BatchEditImages
                  refName="goodsLayerDecorationRef"
                  v-model="self_form.goodsLayerDecoration"
                  :getWidthAndHeights="getWidthAndHeights"
                ></BatchEditImages>
              </div>
              <MutiImgUpload 
                ref="goodsLayerDecorationRef" 
                v-model="self_form.goodsLayerDecoration" 
                :size="150" 
                :mainImgNums="0" 
                :limitWidth="[480, 0]" 
                :limitHeight="[480, 0]" 
                :limitSize="3 * 1024 * 1024" 
                :aspectRatioRange="[0.5, 2]" 
                aspectRatioText="1/2 <= x <= 2" 
              />
            </div>
          </el-form-item>
          <el-form-item label="商品素材图" prop="materialImg">
            <ImgUpload
              ref="materialImgRef"
              :file="self_form.materialImg"
              v-bind="materialImgLimits"
              @upload-success="url => (self_form.materialImg = url)"
              @del="() => (self_form.materialImg = '')"
            />
            <div class="tips">素材图会用于收藏、足迹的场景，图片展示效果可能影响用户下单的转化</div>
          </el-form-item>
          <el-form-item label="主图视频" prop="images">
            <div class="imgs-wrp">
              <el-button @click="shopsUpdateVideo('videoVo')" type="text">店铺上传视频</el-button>
              <el-button @click="videoStateDialog.visible = true" type="text"
                >视频审核详情<video-state :visible.sync="videoStateDialog.visible" :value="[baseItemId]"
              /></el-button>

              <el-row type="flex" align="middle">
                <VideoUpload
                  :video="self_form.videoVo"
                  aspectRatio="1:1,3:4,16:9,4:3"
                  @upload-success="v => handleVideo(v, 1,'videoVo')"
                  @del="v => handleVideo(v, 0,'videoVo')"
                />
              </el-row>
            </div>
            <div class="tips">推荐1:1或3:4；时长≤600秒；大小≤500MB；无黑边、无水印</div>
          </el-form-item>
          <el-form-item label="详情视频" prop="detailVideoDto">
            <div class="imgs-wrp">
              <el-button @click="shopsUpdateVideo('detailVideoDto')" type="text">店铺上传视频</el-button>
              <el-button @click="videoStateDialog.visible = true" type="text"
                >视频审核详情<video-state :visible.sync="videoStateDialog.visible" :value="[baseItemId]"
              /></el-button>

              <el-row type="flex" align="middle">
                <VideoUpload
                  :video="self_form.detailVideoDto"
                  aspectRatio="1:1,3:4,16:9,4:3"
                  @upload-success="v => handleVideo(v, 1,'detailVideoDto')"
                  @del="v => handleVideo(v, 0,'detailVideoDto')"
                />
              </el-row>
            </div>
            <div class="tips">详情视频展示在详情图文顶部；时长≤600秒；大小≤500MB</div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>规格与SKU信息</span>
        </div>
        <div class="conf">
          <el-form-item label="定制商品" prop="personalizationSwitch">
            <el-radio-group v-model="self_form.customizedTechnology.personalizationSwitch" size="mini">
              <el-radio :label="1" border>定制商品</el-radio>
              <el-radio :label="0" border>非定制商品</el-radio>
            </el-radio-group>
            <div class="tips">
              <span style="color: #faad14"
                >定制开启后，需要您及时配置定制模版内容，然后根据消费者上传文字、图片等订单内容对商品进行定制加工，满足消费者个性化需求。</span
              >
            </div>
          </el-form-item>
          <template v-if="self_form.customizedTechnology.personalizationSwitch === 1">
            <el-form-item label="工艺类型" prop="customizedTechnology.technologyType">
              <el-radio-group v-model="self_form.customizedTechnology.technologyType" @change="technologyTypeChange">
                <el-radio v-for="op in technologyTypeOpts" :key="op.value" :label="op.value">{{ op.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label=""
              prop="customizedTechnology.firstType"
              v-if="technologyMap[self_form.customizedTechnology.technologyType]"
            >
              <el-select v-model="self_form.customizedTechnology.firstType" @change="technologyFirstTypeChange">
                <el-option
                  v-for="op in technologyMap[self_form.customizedTechnology.technologyType]"
                  :key="op.id"
                  :value="op.id"
                  :label="op.name"
                ></el-option>
              </el-select>
              <el-select
                v-show="self_form.customizedTechnology.technologyType == 1"
                v-model="self_form.customizedTechnology.twiceType"
                style="margin-left: 10px"
                :disabled="!twiceTypeOpts.length"
              >
                <el-option v-for="op in twiceTypeOpts" :key="op.id" :value="op.id" :label="op.name"></el-option>
              </el-select>
              <el-select
                  v-show="self_form.customizedTechnology.technologyType == 2"
                  v-model="self_form.customizedTechnology.multipleTwiceType"
                  style="margin-left: 10px"
                  collapse-tags
                  multiple
                  :multiple-limit="0"
                  :disabled="!twiceTypeOpts.length"
                >
                    <el-option v-for="op in twiceTypeOpts" :key="op.id" :value="op.id" :label="op.name"></el-option>
                </el-select>
              <div class="tips">工艺类型不同，履约发货时间限制不同，请您根据商品实际定制工艺进行选择，以免造成违约和违规。</div>
            </el-form-item>
          </template>
          <template v-if="categoryId">
            <el-form-item v-if="specTypes.length" label="规格类型:" prop="sizeType">
              <el-radio-group v-model="self_form.sizeType" class="radio-wrap">
                <el-radio :label="item.id" v-for="item in specTypes" :key="item.id">{{ item.name }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="商品规格" prop="specifications">
              <RuleSortBtn :specifications.sync="specifications" />
              <FormItemSpecification
                ref="specificationsRef"
                v-model="specifications"
                :sizeType="self_form.sizeType"
                :catType="self_form.catType"
                :customSpecNum="customSpecNum"
                :specOptions="specOptions"
                :saleProps="salePropList"
                :changeToBase="changeToBase"
                :imgLimits="skuImgLimits"
                @change="specificationsFieldChanged"
                @fieldChanged="specificationsFieldChanged"
              />
              <div v-if="specificationsValidResult !== true" class="el-form-item__error">{{ specificationsValidResult }}</div>
            </el-form-item>
            <el-form-item label="SKU信息" prod="skuList" v-if="specifications.length">
              <MainFormItemSkuList
                ref="formItemSkuListRef"
                v-model="skuList"
                :baseItemId="baseItemId"
                :shopId="shopId"
                :specifications="specifications"
                :showImgCol="self_form.catType != 1"
                :imgOnlyPreview="skuImgOnlyPreview"
                :skcSpec="skcSpec"
                @fieldChanged="specificationsFieldChanged"
              />
              <div v-if="mainFormSkuListErrMsg" class="el-form-item__error">{{ mainFormSkuListErrMsg }}</div>
            </el-form-item>
            <el-form-item v-if="!skcSpec" label="货号" prop="skcExtCode">
              <el-input v-model="self_form.skcExtCode" placeholder="请输入货号" width="300px"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="尺码表" prop="sizeTemplateId" v-if="sizeElementList.length">
              <SizeChart
                ref="sizeChartRef"
                :sizeSpec="sizeSpec"
                :sizeGroupList="sizeGroupList"
                :sizeTemplate="self_form.sizeTemplate"
                :elementList="sizeElementList"
                :shopId="shopId"
                :categoryId="categoryId"
                @validate-errMsg="sizeChartValidError"
              ></SizeChart>
              <div v-if="sizeChartValidErrorMsg" class="el-form-item__error">{{ sizeChartValidErrorMsg }}</div>
          </el-form-item>
          <el-form-item label="模特信息" prop="model" v-if="modelData.enabled"> 
            <ShopModelInfo 
              ref="modelInfoRef"
              :categoryId="categoryId"
              :value="self_form.goodsModelVo" 
              :specifications="specifications" 
              :platform="platform" 
              :shopList="shopList" 
              :enabledModelType="modelData.enabledModelType" 
            />
          </el-form-item>
          <template v-if="skcSpec">
              <el-form-item v-if="skcSpec" label="商品规格（服饰）" prod="productSkcCarouselImage">
                <SkcCarouselImageList ref="skcCarouselImageListRef" :skcSpec="skcSpec" :languages="languages" :isCheckImg="isCheckSkcCarouselImg" @change="skcCarouselImageListChange" />
              </el-form-item>
              <el-form-item label="是否底板或套版" prop="basePlateType" :rules="{ required: true, message: '必填' }">
                <el-radio-group v-model="self_form.basePlateType">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="类型" prop="isBasePlate" v-if="self_form.basePlateType === 1">
                <el-radio-group v-model="self_form.isBasePlate">
                  <el-radio :label="1">底板</el-radio>
                  <el-radio :label="2">套版</el-radio>
                </el-radio-group>
                <div v-if="self_form.isBasePlate == 2" class="tips" style="color:#faad14;">发布完成后请尽快前往 Temu卖家中心【套版组管理】准确完成与底板商品的绑定，完成绑定后方可继续上新流程</div>
              </el-form-item>
              <el-form-item v-if="self_form.basePlateType ==1 && self_form.isBasePlate == 1" label="底板颜色" prop="basePlateSpecValue">
                <el-select v-model="self_form.basePlateSpecValue">
                  <el-option v-for="op in basePlateSpecValueOpts" :key="op.value" :value="op.value" :label="op.label"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <div class="tips">在商品版型和属性不变，仅尺寸或图案细节调整时，可设置商品为底板/套版，套板可套用底版上新信息，提高上新效率。</div>
              </el-form-item>
          </template>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>物流与申报信息</span>
        </div>
        <div class="conf">
          <el-form-item label="商品包装信息" prop="productOuterPackageInfoVo">
            <div style="background-color: #f9f9fa; padding: 20px">
              <el-form-item label="外包装图片：" prop="productOuterPackageImages">
                <div class="imgs-wrp">
                  <div class="ft-12">
                    铺货时只取主图，拖动可调整顺序
                    <BatchEditImages
                      v-model="self_form.productOuterPackageInfoVo.productOuterPackageImages"
                      refName="productOuterPackageImagesRef"
                      :getWidthAndHeights="getWidthAndHeights"
                    ></BatchEditImages>
                  </div>
                  <MutiImgUpload
                    ref="productOuterPackageImagesRef"
                    v-model="self_form.productOuterPackageInfoVo.productOuterPackageImages"
                    :size="150"
                    :limitNums="6"
                    :mainImgNums="0"
                    :placeholderNum="3"
                    :imgNames="['正拍图', '侧拍图', '俯拍图']"
                  />
                </div>
              </el-form-item>
              <el-form-item label-width="12%" style="margin-top: 25px">
                <div class="tips">
                  <div>1. 外包装图片要求1-6张，需包含正拍、侧拍和俯拍图片</div>
                  <div>2. 请确保图片中包含商品分类信息（如：包装上的商品名称、商品说明信息）</div>
                </div>
              </el-form-item>
              <el-form-item label="外包装类型：" prop="packageType">
                <el-radio-group v-model="self_form.productOuterPackageInfoVo.productOuterPackage.packageType" size="mini">
                  <el-radio v-for="op in packageTypeOpts" :key="op.value" :label="op.value" border>{{ op.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label-width="12%" style="margin-top: 20px">
                <div class="tips">
                  <div>硬包装：外包装为原色瓦楞纸箱，或者彩色纸箱已塑封：如笔记本电脑，电饭煲，带鞋盒的鞋子等</div>
                  <div>软包装+硬物：商品外包装形状会随着挤压会改变形状，但商品不会；如笔记本、手串装饰等</div>
                  <div>软包装+软物：商品外包装及商品形状会随着挤压会改变形状；如衣服，毛绒玩具等</div>
                </div>
              </el-form-item>
              <el-form-item label="外包装形状：" prop="packageShape">
                <el-radio-group v-model="self_form.productOuterPackageInfoVo.productOuterPackage.packageShape" size="mini">
                  <el-radio v-for="op in packageShapeOpts" :key="op.value" :label="op.value" border>{{ op.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="敏感属性与体积重量" prod="skuListExtend" v-if="specifications.length">
            <FormItemSkuListExtends
              ref="formItemSkuListExtendRef"
              :specifications="specifications"
              :categoryId="categoryId"
              v-model="skuList"
              :showImgCol="false"
              @fieldChanged="specificationsFieldChanged"
            >
            </FormItemSkuListExtends>
            <div v-if="formSkuListExtendsErrMsg" class="el-form-item__error">{{ formSkuListExtendsErrMsg }}</div>
          </el-form-item>
          <el-form-item label="电子说明书：" prop="productGuideFile">
            <div>
              <el-upload
                ref="productGuideFileUpload"
                :disabled="productGuideFileUploading"
                class="upload-btn"
                action="#"
                accept=".pdf"
                multiple
                :limit="30"
                :file-list="self_form.productGuideFile"
                :auto-upload="false"
                :on-preview="productGuidePreview"
                :on-remove="productGuideFileRemove"
                :on-change="productGuideFileChange"
                :on-exceed="productGuideExceed"
              >
                <el-button size="small"> 上传文件（{{ self_form.productGuideFile.length }}/30）</el-button>
                <div slot="tip" class="tips">
                  <div>1. 说明书尽可能覆盖更多语言将有效提高转化和降低客诉</div>
                  <div>2. 仅支持上传PDF，文件需在50M以内</div>
                </div>
              </el-upload>
            </div>
          </el-form-item>
          <!-- <el-form-item label="承诺发货时效" prop="productGuideFile">
            <el-radio-group v-model="self_form.productGuideFile">
              <el-radio :label="1">1个工作日内发货</el-radio>
              <el-radio :label="2">2个工作日内发货</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <!-- <el-form-item label="运费模版" prop="productGuideFile">
            <TemplateBlock v-if="shopList.length" :shopList="shopList" v-model="self_form.xhsShopShippingTemplateList"></TemplateBlock>
          </el-form-item> -->
        </div>
      </section>
    </el-form>
    <ShopDialog :data="shopList" ref="ShopDialogRef"></ShopDialog>
  </div>
</template>
<script>
import '@/assets/css/prod.scss';
import VideoUpload from '@/components/Uploads/videoUpload';
import VideoState from './components/VideoState.vue';
import ImgUpload from '@/components/Uploads/ImgUpload';
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue';
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue';
import CategoryInput from '../PlatformCategoryInput/index.vue';
import CategoryProps from './components/CategoryProps/index.vue';
import ShopBrands from './components/ShopBrands.vue';
import ShopDialog from './components/ShopDialog.vue';
import CarouselImages from './components/CarouselImages.vue';
import SkcCarouselImageList from './components/SkcCarouselImageList.vue';
import FormItemSkuListExtends from './components/FormItemSkuListExtends/index.vue';
import MainFormItemSkuList from './components/MainFormItemSkuList.vue';
import SizeChart from './components/SizeCharts.vue';
import FormItemSpecification from './components/FormItemSpecification.vue';
import TemplateBlock from './components/TemplateBlock.vue';
import SizeChartTemp from './components/sizeChartTemp.vue';
import ShopModelInfo from './components/ShopModelInfo.vue';

import { specification_mixin } from '../FormItemSpecification';
import { editor_mixin } from '@/components/Editor/index.js';
import validateMixin from '../validateMixin';
import shopListMixin from '../shopListMixin';
import { getBytesCount } from '@utils/data';
import { getCrossborderConfig } from '@servers/prod/conf/index.js';
import { capitalizeFirstLetter } from '@/utils';
import {
  getCategoryProperties,
  getParentSpec,
  uploadCarouselVideo,
  editCarouselVideo,
  getProductSkuWhExtAttr,
  defaultProductSkuSuggestedPrice,
  defaultProductSkuUsSuggestedPrice,
  defaultProductSkuMultiPack,
  getDefaultProductSkuAccessories,
  getSizechartsMeta,
  getModelCats,
} from '@/servers/prod/center/temu.js';
import RULES from './rules.js';
import { LANGUAGE_MAP } from '@/dictionary/i18n.js'
import constantConfigs,{getDefaultProductWhExtAttr,getDefaultProductOuterPackageInfo} from './config';

import { cloneDeep, isEmpty, merge, isEqual } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import OSSClient from '@/components/Uploads/OSS-client';

// 提取默认对象初始化
const getDefaultCustomizedTechnology = (data = {}) => {
  const v = {
    firstType: '',
    technologyType: '1',
    twiceType:'', // 工艺分类第二个下拉框组件--单选
    multipleTwiceType:[],// 工艺分类第二个下拉框组件--多选(仅前端使用，字段不需要传给后端)
    ...data,
  };
  if(typeof v.twiceType === 'string'){
    v.twiceType = v.twiceType.split(',')
  }
  return v;
};

export default {
  mixins: [specification_mixin, validateMixin, editor_mixin, shopListMixin],
  provide: {
    platform: 'pddtemu',
  },
  inject: {
    isGroupPuhuo: { default: false },
  },
  components: {
    VideoUpload,
    VideoState,
    MutiImgUpload,
    ImgUpload,
    BatchEditImages,
    GroupImagesList,
    CategoryInput,
    CategoryProps,
    FormItemSpecification,
    ShopBrands,
    ShopDialog,
    CarouselImages,
    SkcCarouselImageList,
    FormItemSkuListExtends,
    MainFormItemSkuList,
    SizeChart,
    TemplateBlock,
    SizeChartTemp,
    ShopModelInfo,
  },
  props: {
    form: {
      type: Object,
      default() {
        return {};
      },
    },
    baseItemId: [Number, String],
    changeToBase: Function,
  },
  data() {
    return {
      platform: 'pddtemu',
      ...constantConfigs,
      LANGUAGE_MAP,
      languages: ['en'],
      initAttrData: [],
      initCarouselImage: [],
      self_form: {
        categoryIds: [],
        catType: 0, // 类目类型 (0: 未分类, 1: 服饰)
        productName: '', // 商品名称
        productEnName: '', // 商品英文名称
        productWhExtAttrVo: getDefaultProductWhExtAttr(),
        customizedTechnology: getDefaultCustomizedTechnology(),
        productOuterPackageInfoVo: getDefaultProductOuterPackageInfo(),
        shopBrandConf: [], // 品牌
        productProperty: [], // 商品属性
        carouselImage: [], // 商品轮播图
        videoVo: null, // 主图视频
        videoId: null,
        detailVideoDto:null, // 详情视频
        detailVideoId:null,// 详情视频 id
        specifications: [],
        skuList: [],
        sizeType: 1, // 尺码类型
        productSkcCarouselImage: [], // 规格轮播图
        sizeTemplateId: '', // 尺码表模版
        materialImg: '', // 商品素材图
        isBasePlate: 0, // 底板/套版 (0: 都不是, 1: 底板, 2: 套版)
        basePlateType:0, // 是否底板或套版
        basePlateSpecValue: '', // 底板颜色
        goodsLayerDecoration: [], // 图文详情
        productGuideFile: [],
        skcExtCode:'', // 货号（非服饰类目）
        goodsModelVo:[], // 模特信息
      },
      // carouselImagesLimits: {
      //   limitSize: 2 * 1024 * 1024,
      //   limitHeight: [800, 0],
      //   limitWidth: [800, 0],
      //   limitNums: 10,
      //   aspectRatio: [1],
      //   aspectRatioText: '1:1',
      //   imgNames: [],
      // },
      videoStateDialog: { visible: false, data: null },
      specOptions: [],
      rules: RULES(this),
      showGroupImages: true,
      specificationsValidResult: true,
      mainFormSkuListErrMsg: '',
      formSkuListExtendsErrMsg: '',
      originalShopBrandConf: null, // 原始品牌配置（用于保存时恢复未显示店铺的数据）
      sizeChartValidErrorMsg: '',
      skuSpecificationsKey: 'skuSpecifications',
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      fetchAttrsShopIndexs: [],
      customSpecNum: 2,
      salePropList: [],
      categoryProperties: [],
      brandProp: {},
      sizeGroupList: [],
      sizeElementList: [],
      productGuideFileUploading: false,
      isPureType: false,
      detailType:'en',
      productOriginImg:'',
      productOriginFileList:[], // 产地证明
      autoCropImageConfigList:[], // 图片自动修正
      modelData:{},//模特数据 
    };
  },
  computed: {
    ...mapGetters(['shops_updateIndex', 'shops_getCategoryPropShopId']),
    shopList() {
      return this.getShopList(this.platform);
    },
    shopId() {
      return this.shops_getCategoryPropShopId(this.platform);
    },
    shopAllList() {
      return this.$store.getters.get_AllShops_BySource(this.platform);
    },
    categoryId() {
      let categoryIds = this.self_form.categoryIds || [];
      return categoryIds.length ? categoryIds[categoryIds.length - 1] : '';
    },
    specTypes() {
      const sizeItem = this.salePropList.find(s => s.name === '尺码');
      if (!sizeItem) return [];
      let arr = sizeItem.values.reduce((acc, it) => {
        if (it.group) {
          const isMatch = acc.some(a => a.id === it.group.id);
          if (!isMatch) {
            acc.push(it.group);
          }
        }
        return acc;
      }, []);
      const idx = arr.findIndex(a => a.id === this.self_form.sizeType);
      if (idx === -1 && arr[0]) {
        this.self_form.sizeType = arr[0].id;
      }
      return arr;
    },
    sizeSpec() {
      return this.specifications?.find(s => this.sizeGroupList.some(g => g.name === s.name));
    },
    skcSpec() {
      // return false
      return this.specifications?.find(s => s?.extendValues?.isSkc);
    },
    basePlateSpecValueOpts() {
      let basePlateSpecValueOpts = [];
      const colorSpec = this.specifications?.find(s => s.name === '颜色');
      if(colorSpec) {
        basePlateSpecValueOpts = colorSpec.values?.map(item => ({
          label: item.value,
          value: item.value,
        })) || [];
      }

      return basePlateSpecValueOpts;
    },
    twiceTypeOpts() {
      let twiceTypeOpts = [];
      const technologyType = this.self_form.customizedTechnology.technologyType;
      const firstType = this.self_form.customizedTechnology.firstType;
      if (technologyType && firstType) {
        const findItem = this.technologyMap[technologyType].find(item => item.id === firstType);
        twiceTypeOpts = findItem?.childDetail?.length ? findItem?.childDetail : [];
      }
      return twiceTypeOpts;
    },
    carouselImagesLimits(){
      let isCheckImg = !this.autoCropImageConfigList.includes('CarouselImg');
      return {
        limitSize: isCheckImg ? 2 * 1024 * 1024 : null,
        limitHeight: isCheckImg ? [800, 0]:[0,0],
        limitWidth: isCheckImg ? [800, 0]:[0,0],
        limitNums: 10,
        aspectRatio: isCheckImg ? [1] : 0,
        aspectRatioText: '1:1',
        imgNames: [],
      }
    },
    isCheckSkcCarouselImg(){
      let isCheckImg = !this.autoCropImageConfigList.includes('SkcCarouselImg');
      return isCheckImg
    },
    descLimits(){
      let isCheckImg = !this.autoCropImageConfigList.includes('Desc');
      return {
        limitSize: isCheckImg ? 2 * 1024 * 1024 : null,
        limitHeight: isCheckImg ? [800, 0]:[0,0],
        limitWidth: isCheckImg ? [800, 0]:[0,0],
        limitNums: 10,
        aspectRatio: isCheckImg ? [1] : 0,
        aspectRatioText: '1:1',
        imgNames: [],
      }
    },
    skuImgLimits(){
      let isCheckImg = !this.autoCropImageConfigList.includes('SkuImg');
      return {
        limitSize: isCheckImg ? 2 * 1024 * 1024 : null,
        limitHeight: isCheckImg ? [800, 0]:[0,0],
        limitWidth: isCheckImg ? [800, 0]:[0,0],
        limitNums: 1,
        aspectRatio: isCheckImg ? [1] : 0,
        aspectRatioText: '1:1',
      }
    },
    materialImgLimits(){
      let isCheckImg = !this.autoCropImageConfigList.includes('MaterialImg');
      return {
          isSingle:true,
          limitSize: isCheckImg ? 2 * 1024 * 1024 : null,
          limitWidth: isCheckImg ? [800, 0] : [0,0],
          limitHeight: isCheckImg ? [800, 0] : [0,0],
          aspectRatio: isCheckImg ? [1] : 0,
          aspectRatioText:"1:1"
      }
    },
  },
  watch: {
    form: {
      async handler(v) {
        if (isEmpty(v)) return;
        await this.getSpecNameList();
        // 保存原始 shopBrandConf，用于保存时恢复未显示店铺的数据
        if (v.shopBrandConf && v.shopBrandConf.length) {
          this.originalShopBrandConf = cloneDeep(v.shopBrandConf);
        }
        const data = merge(cloneDeep(this.self_form), v);
        if(data.isBasePlate == 1 || data.isBasePlate == 2){
          data.basePlateType = 1
        }else{
          data.isBasePlate = null
          data.basePlateType = 0
        }
        data.productGuideFile = data.productGuideFile.map(pg => {
          return {
            name: pg.fileName,
            url: pg.url,
            language: pg.language || 'en',
            shopIdPdfIdMap: pg.shopIdPdfIdMap || null,
          };
        });
        if(!data.productOuterPackageInfoVo){
          data.productOuterPackageInfoVo = getDefaultProductOuterPackageInfo()
        }else{
          data.productOuterPackageInfoVo.productOuterPackageImages = (data.productOuterPackageInfoVo.productOuterPackageImages || [])
            .map(imaItem => imaItem.imageUrl)
            .filter(Boolean);
        }
        data.goodsLayerDecoration = data.goodsLayerDecoration.map(item => item.imgUrl).filter(Boolean);
        // 定制商品工艺类型处理
        if(data.customizedTechnology.technologyType == 2){
            data.customizedTechnology.multipleTwiceType = data.customizedTechnology.twiceType
            data.customizedTechnology.twiceType = ''
        }else{
            data.customizedTechnology.twiceType = data.customizedTechnology.twiceType ? data.customizedTechnology.twiceType[0] : ''
        }
        if(data.productWhExtAttrVo){
            this.productOriginFileList = (data.productWhExtAttrVo.productOriginCertFiles || []).filter(i => i.fileUrl).map(i => ({
                name: i.fileName,
                url: i.fileUrl
            }));
            if(this.productOriginFileList[0]){
              this.productOriginImg = this.productOriginFileList[0].url
            }
        }else{
          data.productWhExtAttrVo = getDefaultProductWhExtAttr()
        }
        if(!data?.detailVideoDto?.length){// 默认赋null
          data.detailVideoDto = null
        }
        this.$set(this, 'initAttrData', cloneDeep(data.productProperty || []));
        this.$set(this, 'initCarouselImage', cloneDeep(data.carouselImage || []));
        this.$set(this, 'self_form', data);
        this.getConf();
        this.$nextTick(() => {
          this.validPage();
        });
      },
      immediate: true,
    },
    categoryId: {
      handler(val) {
        if (val) {
          this.getCategoryProps();
          this.getMeta();
          this.getModelInfo();
        }
      },
      immediate: true,
    },
    shopId: {
      handler(val) {
        if (val) {
          this.getSpecNameList();
        }
      },
    },
    'self_form.carouselImage': {
      handler(v) {
        if (!this.self_form.materialImg && v?.length && v[0]?.url?.length) {
          this.self_form.materialImg = v[0].url[0];
        }
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    ...mapActions(['updateCatePropShopIndex']),
    createSkuListBySpecs(v) {
      const that = this;
      const originSkuList = cloneDeep(this.self_form.skuList);
      v = v.filter(item => item.name && item.checked);
      if (this.isPureType) {
        // 纯商品
        this.skuList = [
          {
            ...cloneDeep(this.computedValueForm),
            ...originSkuList[0],
            skuSpecifications: [],
            currencyType: 'CNY',
          },
        ];
        return;
      }
      // 检查是否有规格值 - 不生成skulist
      const hasNoValues = !v.some(item => item.name && item.values.length && item.values.some(i => i.checked));
      if (hasNoValues) {
        this.skuList = [];
        return;
      }
      let _skuList = [];
      const oldSkuList = cloneDeep(this.skuList);
      function forEach(arr, index = 0, c_arr = []) {
        // 取到最后一层开始作业务逻辑
        if (arr.length === index) {
          // 若有值为空或未勾选不做任何处理
          if (c_arr.some(item => !item.value || !item.checked)) return;

          const valueKeys = c_arr.filter(item => !!item.valueKey).map(item => item.valueKey);
          const _skuid = valueKeys.join('-'); // 生成skuid
          const _skuSpecifications = c_arr.map((item, index) => {
            //生成sku明细
            const _sp = {
              checked: that.getChecked(v[index].nameKey, item.valueKey, v),
              name: v[index].name,
              value: item.value,
              nameKey: v[index].nameKey,
              valueKey: item.valueKey,
            };
            if (index === 0) {
              _sp.imageUrl = that.getSkuImageUrl({
                item,
                valueKeys,
                originSkuList,
                skuList: oldSkuList,
                skuImgOnlyPreview: that.skuImgOnlyPreview,
              });
            }
            return _sp;
          });
          // 1. 现在当前skuList中找有无数据
          // 2. 在self_form中找有无数据
          // 3. 生成一个全新skuitem

          let skuItem = {
            valueKeys,
            _skuid,
            skuSpecifications: _skuSpecifications,
            currencyType: 'CNY', // 先默认写死（申报价格单位： 人民币）
          };
          const copyImgToSkuImg = sItem => {
            const imgUrl = _skuSpecifications[0] && _skuSpecifications[0].imageUrl;
            if (imgUrl) {
              sItem.skuImg = sItem.skuImg || imgUrl;
            }
          };
          // --- 1
          const thisSkuObj = that.findSkuListItem(oldSkuList, valueKeys);
          const thisSku = thisSkuObj.item;
          if (thisSku) {
            let imgUrl = _skuSpecifications[0] && _skuSpecifications[0].imageUrl;
            skuItem = {
              ...thisSku,
              ...skuItem,
              skuImg: imgUrl, // 配置是否变更规格图片 0 不变更 1 变更
            };
            _skuList.push(skuItem);
            oldSkuList.splice(thisSkuObj.index, 1);
            return;
          }
          // --- 2
          const selfSkuObj = that.findSkuListItem(originSkuList, valueKeys);
          const selfSku = selfSkuObj.item;
          if (selfSku) {
            skuItem = {
              ...selfSku,
              ...skuItem,
            };
            copyImgToSkuImg(skuItem);
            _skuList.push(skuItem);
            originSkuList.splice(selfSkuObj.index, 1);
            return;
          }
          // --- 3
          skuItem = {
            ...cloneDeep(that.self_form.skuList[0]),
            ...skuItem,
            id: '',
            baseSkuId: '',
            extCode: '',
            outId: '',
            ...cloneDeep(that.computedValueForm),
            productSkuAccessories: getDefaultProductSkuAccessories(),
            productSkuWhExtAttr: getProductSkuWhExtAttr({}),
            productSkuSuggestedPrice: cloneDeep(defaultProductSkuSuggestedPrice),
            productSkuUsSuggestedPrice: cloneDeep(defaultProductSkuUsSuggestedPrice),
            productSkuMultiPack: cloneDeep(defaultProductSkuMultiPack),
          };
          copyImgToSkuImg(skuItem);
          _skuList.push(skuItem);

          return;
        }

        // 取出一层
        let currItem = arr[index];
        // 此层值循环
        currItem.values.forEach(c => {
          // 每个值再递归取
          forEach(arr, index + 1, c_arr.concat(c));
        });
      }
      forEach(v);
      this.skuList = _skuList;
      window.__spcificationImg_changed = '';
      window.__spcificationCheckbox_changed = false;
    },
    getSkuImageUrl({ item, valueKeys, originSkuList, skuList, skuImgOnlyPreview }) {
      // 获取sku图片的逻辑统一处理
      if (!skuImgOnlyPreview && !window.__spcificationImg_changed) {
        const selfSku = this.findSkuListItem(originSkuList, valueKeys).item;
        if (selfSku && !window.__spcificationCheckbox_changed) {
          return selfSku.imageUrl || selfSku['skuSpecifications'][0]?.imageUrl || '';
        }

        const thisSku = this.findSkuListItem(skuList, valueKeys).item;
        if (thisSku?.['skuSpecifications'][0]?.imageUrl) {
          return thisSku.imageUrl || thisSku['skuSpecifications'][0].imageUrl;
        }
        return item.imageUrl || '';
      }

      if (window.__spcificationImg_changed) {
        if (valueKeys.join('-').indexOf(window.__spcificationImg_changed) > -1) {
          return item.imageUrl || '';
        }
        const thisSku = this.findSkuListItem(skuList, valueKeys).item;
        if (thisSku) {
          return thisSku['skuSpecifications'][0]?.imageUrl || item.imageUrl || '';
        }
      }

      return item.imageUrl || '';
    },
    findSkuListItem(list, valueKeys) {
      const otherData = {};
      let index = list.findIndex(sku => isEqual(sku.valueKeys, valueKeys));
      if (index === -1) {
        index = list.findIndex(
          sku => valueKeys.every(key => (sku.valueKeys || []).includes(key)) || sku.valueKeys.every(key => (valueKeys || []).includes(key))
        );
        otherData.id = null;
      }
      return {
        index,
        item: index > -1 ? { ...list[index], ...otherData } : null,
      };
    },
    categoryChange(categoryIds, labels, lastLevelCateGory) {
      this.self_form.catType = lastLevelCateGory?.catType || 0;
    },
    technologyTypeChange(v) {
      this.self_form.customizedTechnology.firstType = '';
      this.technologyFirstTypeChange();
    },
    technologyFirstTypeChange(v) {
      this.self_form.customizedTechnology.twiceType = ''
      this.self_form.customizedTechnology.multipleTwiceType = [];
    },
    // 获取规格名列表
    async getSpecNameList() {
      const specOptions = await getParentSpec({
        // leafCategoryId: this.categoryId,
        shopId: this.shopId,
      });
      this.specOptions = specOptions;
    },
    switchShopHandle(shopId) {
      this.getCategoryProps(false, shopId);
    },
    async getCategoryProps(isUpdate, shopId) {
      isUpdate && this.updateCatePropShopIndex(this.platform);
      shopId = shopId || this.shopId;
      if (!this.categoryId || !shopId) return;
      let res = await getCategoryProperties({
        leafCategoryId: this.categoryId,
        shopId,
      });
      const updateIndex = this.shops_updateIndex(this.platform);
      if (!res) {
        // 如果当前店铺查不到数据，查下一个店铺数据
        if (!this.fetchAttrsShopIndexs.includes(updateIndex)) {
          this.fetchAttrsShopIndexs.push(updateIndex);
          this.getCategoryProps(true);
        }
        return;
      }
      let { properties, inputMaxSpecNum } = res;
      let salePropList = [];
      this.brandProp = {};
      const categoryProperties = properties.filter(prop => {
        if (prop.name === '品牌名') {
          this.brandProp = prop;
        } else if (prop.isSale) {
          if (prop.mainSale) {
            salePropList.unshift(prop);
          } else {
            salePropList.push(prop);
          }
        } else {
          return true;
        }
        return false;
      });
      this.categoryProperties = categoryProperties; // 商品属性
      this.salePropList = salePropList;
      this.specifications = this.getSpecifications(salePropList, inputMaxSpecNum);
    },
    getSpecifications(saleProps, inputMaxSpecNum) {
      // 1、inputMaxSpecNum = 0 && saleProps.length > 0, 只能有销售属性
      // 2、inputMaxSpecNum = 0 && saleProps.length = 0, 可以有自定义属性（非销售属性）最多2个
      // 3、inputMaxSpecNum > 0, 自定义属性（非销售属性）最多为inputMaxSpecNum个
      let customSpecNum = saleProps.length ? inputMaxSpecNum : inputMaxSpecNum || 2;
      this.customSpecNum = customSpecNum;
      const salePropList = cloneDeep(saleProps).sort((a, b) => b.required - a.required);
      const specifications = cloneDeep(this.self_form.specifications);

      // 获取未匹配的规格名
      const getUnmatchedNames = (specs, saleProps) =>
        specs
          .filter(s => !saleProps.some(sp => s.name === sp.name || s.name.includes(sp.name) || sp.name.includes(s.name)))
          .map(s => s.name);

      let unmatchedNames = getUnmatchedNames(specifications, salePropList);
      const specs = [];
      const unMatchedSalePropList = [];
      // 查找规格索引
      const findSpecIndex = (specs, name) => specs.findIndex(item => item.name === name);

      // 模糊查找规格索引
      const fuzzyFindSpecIndex = (specs, name) =>
        specs.findIndex(item => item.name && name && (item.name.includes(name) || name.includes(item.name)));
      // 处理销售属性
      salePropList.forEach(saleProp => {
        // 根据name精确匹配
        let specIdx = findSpecIndex(specifications, saleProp.name);
        // 再模糊匹配
        if (specIdx === -1) {
          specIdx = fuzzyFindSpecIndex(specifications, saleProp.name);
        }
        // 未匹配的name也不在非销售属性中，也添加在销售属性中
        if (specIdx === -1 && unmatchedNames.length) {
          const unNIndex = unmatchedNames.findIndex(un => !this.specOptions.some(so => un === so.parentSpecName));
          if (unNIndex > -1) {
            specIdx = specifications.findIndex(item => item.name === unmatchedNames[unNIndex]);
            unmatchedNames.splice(unNIndex, 1);
          } 
        }
        // 必填项
        if(specIdx === -1 && saleProp.required) {
          specIdx = 0;
          const unNIndex = unmatchedNames.findIndex(un => un === saleProp.name);
          if(unNIndex > -1) {
            unmatchedNames.splice(unNIndex, 1);
          }
        }
        if (specIdx > -1) {
          let spec = this.initSpec(saleProp);
          const findSpecItem = specifications[specIdx];
          spec.checked = saleProp.required ? true : !!findSpecItem.checked;
          spec.values = this.initSpecValues(findSpecItem, saleProp);
          specifications.splice(specIdx, 1);
          specs.push(spec);
        } else {
          unMatchedSalePropList.push(saleProp);
        }
      });
      // 自定义属性（非销售属性）
      if (specifications.length && (customSpecNum || unMatchedSalePropList.length)) {
        // const sortSpecifications = specifications.sort((a, b) => this.specOptions.some(option => option.parentSpecName === b.name) - this.specOptions.some(option => option.parentSpecName === a.name));
        specifications.forEach(s => {
          if (customSpecNum) {
            // 检查自定义规格名是否是通用属性列表中规格项
            const parentSpecId = this.getParentSpecId(s.name);
            const spec = { ...s, isSale: false, extendValues: { parentSpecId, isSkc: false } };
            (spec.values || []).forEach(v => {
              v.name = spec.name;
              v.extendValues = {
                parentSpecId,
                specId: '',
              };
            });
            specs.push(spec);
            customSpecNum--;
          } else if (unMatchedSalePropList.length) {
            const saleProp = unMatchedSalePropList.shift();
            let spec = this.initSpec(saleProp);
            spec.checked = !!s.checked
            spec.values = this.initSpecValues(s, saleProp);
            specs.push(spec);
            customSpecNum--;
          }
        });
      }
      this.isPureType = !specs.length;
      if (specs?.length) {
        let checkedSpec = specs.find(s => s.checked);
        if (!checkedSpec) {
          checkedSpec = specs[0];
          checkedSpec.checked = true;
        }
        checkedSpec.showImg = this.catType !== 1;
      }
      return specs;
    },
    initSpec(saleProp) {
      let valueUnit = (saleProp.valueUnit || []).filter(Boolean);
      valueUnit = valueUnit.length ? valueUnit : undefined;
      return {
        checked: false,
        required: saleProp.required,
        name: saleProp.name,
        nameKey: saleProp.nameKey || saleProp.name,
        isSale: true,
        allowCreate: saleProp.controlType === 3,
        canNote: saleProp.canNote,
        refPid: saleProp.refPid,
        valueUnit,
        values: [],
        extendValues: {
          parentSpecId: saleProp.parentSpecId,
          isSkc: saleProp.parentSpecId == '1001' && this.self_form.catType == 1,
        },
      };
    },
    initSpecValues(specValueItem={}, saleProp) {
      let values = [];
      let valueUnit = (saleProp.valueUnit || []).filter(Boolean);
      valueUnit = valueUnit.length ? valueUnit : undefined;
      if (specValueItem?.values?.length) {
        values = specValueItem.values.map(propV => {
          const val = {
            refPid: saleProp.refPid,
            name: saleProp.name,
            checked: propV.checked,
            value: propV.vvalue || propV.value,
            valueKey: propV.valueKey,
            groupId: propV.groupId,
            vid: propV.vid,
            note: propV.note || '',
            imageUrl: propV.imageUrl,
            extendValues: {
              ...propV.extendValues,
              parentSpecId: saleProp.parentSpecId,
              specId: propV?.extendValues?.specId || '',
            },
          };
          if (valueUnit && !val.extendValues.specValue) {
            val.extendValues.specValue = { value: '', valueUnit: '' };
            val.value = '';
          }
          if (propV.extendValues?.parentSpecId !== saleProp.parentSpecId) {
            val.extendValues.specId = '';
          }
          return val;
        });
      }
      return values;
    },
    getParentSpecId(name) {
      const specOptions = this.specOptions;
      if (!specOptions?.length) return;
      const idx = specOptions.findIndex(option => option.parentSpecName === name);
      if (idx !== -1) {
        const item = specOptions[idx];
        return item.parentSpecId;
      }
      return '';
    },
    skcCarouselImageListChange(skcImageList) {
      const skcSpec = this.specifications?.find(s => s?.extendValues?.isSkc);
      skcSpec.values.forEach(v => {
        const findItem = skcImageList.find(skc => skc.value === v.value);
        const product_skc = {
          ...v.extendValues.product_skc,
          extCode: findItem.extCode,
          previewImgUrls: findItem.previewImgUrls,
        };
        v.extendValues.product_skc = product_skc;
      });
    },
    productGuideFileChange(v, fileList) {
      const file = v.raw;
      this.productGuideFileUploading = true;
      const companyId = this.$store.getters.userInfo.companyId;
      OSSClient.getInstance().singleUpload(`scm/${companyId}/${Date.now()}/${file.name}`, file, {
        success: res => {
          this.productGuideFileUploading = false;
          this.self_form.productGuideFile.push({
            name: file.name,
            url: res.url,
            language: 'en',
          });
        },
        fail: res => {
          this.productGuideFileUploading = false;
          this.$message.error('上传失败,请重新上传');
        },
      });
    },
    regionChange(v){
      this.self_form.productWhExtAttrVo.productOrigin.region2Id = ''
      if(v === 'CN'){// 重置证明文件
        let obj = getDefaultProductWhExtAttr()
        this.self_form.productWhExtAttrVo.productOriginCertFiles = obj.productOriginCertFiles
        this.productOriginImg = ''
        this.productOriginFileList = []
      }
    },
    productOriginFileChange(v,fileList){
      const file = v.raw;
      const companyId = this.$store.getters.userInfo.companyId;
      this.productOriginFileList = fileList
      OSSClient.getInstance().singleUpload(`scm/${companyId}/${Date.now()}/${file.name}`, file, {
        success: res => {
          let f = {
            fileName:file.name,
            fileUrl:res.url
          }
          this.self_form.productWhExtAttrVo.productOriginCertFiles = [f]
          this.productOriginImg = res.url;
        },
        fail: res => {
          this.$message.error('上传失败,请重新上传');
        },
      });
    },
    productGuideFileRemove(file, fileList) {
      this.self_form.productGuideFile = fileList;
    },
    productOriginFileRemove(file, fileList) {
      this.productOriginImg = '';
      this.self_form.productWhExtAttrVo.productOriginCertFiles[0].fileUrl = ''
    },
    productGuidePreview(file) {
      window.open(file.url, '_blank');
    },
    productOriginPreview(file) {
      window.open(this.productOriginImg, '_blank');
    },
    productGuideExceed(file, fileList) {
      this.$message.warning('上传文件数量超过上限啦！');
    },

    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : [];
    },
    sizeChartValidError(errMsg) {
      this.sizeChartValidErrorMsg = errMsg;
      this.getErrorCount();
    },
    // 上传视频
    async handleVideo(value, type,key) {
      let map = {
        videoVo:'videoId',
        detailVideoDto:'detailVideoId'
      }
      let id = map[key]
      // type 0 删除 1 成功
      this.self_form[key] = type === 1 ? { ...value } : null;
      this.self_form[id] = null;

      if (this.self_form[key]) {
        const videoId = await editCarouselVideo({
          videoVo: this.self_form[key],
          baseItemId: this.baseItemId,
        });
        this.self_form[id] = videoId;
      }
    },
    shopsUpdateVideo(key) {
      if (!this.self_form[key]) {
        this.$message.warning('请先添加视频后上传店铺！');
      } else {
        this.$refs.ShopDialogRef.method_open({
          okFn: async shopIds => {
            let res = await uploadCarouselVideo({
              baseItemIds: [this.baseItemId],
              shopIds,
            });
            if (res) {
              this.$message.success('上传视频成功！');
            }
          },
        });
      }
    },
    async valid_specifications() {
      this.specificationsValidResult = true;
      this.mainFormSkuListErrMsg = '';
      this.formSkuListExtendsErrMsg = '';
      let validSpecId = true;
      let validSkcCarouse = true;
      if (this.$refs.specificationsRef) {
        validSpecId = await this.$refs.specificationsRef.validate();
      }

      if (this.$refs.skcCarouselImageListRef) {
        validSkcCarouse = await this.$refs.skcCarouselImageListRef.validate();
      }

      if (this.$refs.formItemSkuListRef) {
        const mainFormSkuListErrMsg = await this.$refs.formItemSkuListRef.validate();
        if (mainFormSkuListErrMsg) {
          this.mainFormSkuListErrMsg = mainFormSkuListErrMsg;
        }
      }
  
      if (this.$refs.formItemSkuListExtendRef) {
        const formSkuListExtendsErrMsg = await this.$refs.formItemSkuListExtendRef.validate();
        if (formSkuListExtendsErrMsg) {
          this.formSkuListExtendsErrMsg = formSkuListExtendsErrMsg;
        }
      }

      const specificationsValid = await this.validateSpecifications();
      if (specificationsValid !== true) {
        this.specificationsValidResult = specificationsValid;
      }
      if (!validSpecId || !validSkcCarouse || this.mainFormSkuListErrMsg || this.formSkuListExtendsErrMsg || specificationsValid !== true) {
        return false;
      }

      return true;
    },
    async valid_form() {
      return new Promise(async resolve => {
        if (!this.$refs.form) {
          resolve(false);
          return false;
        }
        const form = new Promise(resolve => {
          this.$refs.form.validate(valid => {
            resolve(valid);
          });
        });
        const promises = [form];
        if (this.$refs.catepropsRef) {
          promises.push(this.$refs.catepropsRef.validate());
        }
        if (this.$refs.ShopBrandsRef) {
          promises.push(this.$refs.ShopBrandsRef?.method_validate());
        }
        if (this.$refs.carouselImagesRef) {
          promises.push(this.$refs.carouselImagesRef?.validate());
        }
        // 模特
        if(this.modelData.required && this.$refs.modelInfoRef){
          promises.push(this.$refs.modelInfoRef.valid())
        }
        Promise.all(promises)
          .then(valids => {
            const allIsValid = valids.every(item => {
              return item === true;
            });
            resolve(allIsValid);
          })
          .then(() => {
            resolve(false);
          });
      });
    },
    method_getFormData(cb) {
      return new Promise((resolve, reject) => {
        this.validPage().then(async valid => {
          if (!valid || this.sizeChartValidErrorMsg) {
            this.$message.error('请完善表单');
            resolve(false);
            return;
          }
          const widthAndHeight = this.getWidthAndHeights('goodsLayerDecorationRef');
          const skuList = cloneDeep(this.skuList);
          if (this.catType !== 1) {
            skuList.forEach(sku => {
              const skuS = sku.skuSpecifications.find(skuS => skuS.imageUrl) || {};
              sku.thumbUrl = JSON.stringify([
                {
                  language: 'en',
                  url: skuS.imageUrl || '',
                },
              ]);
            });
          }
          skuList.forEach(sku => {
            let productSkuWhExtAttr = sku.productSkuWhExtAttr
            let { productSkuBarCodeReqs } = productSkuWhExtAttr
            if(productSkuBarCodeReqs){
              let arr = productSkuBarCodeReqs.filter(i => i.code && i.codeType);
              productSkuWhExtAttr.productSkuBarCodeReqs = arr.length ? productSkuBarCodeReqs : null
            }
          });
          let _formdata = {
            ...cloneDeep(this.self_form),
            specifications: this.formatSpecifications(this.specifications),
            skuList,
            sizeTemplate: {},
            categoryLeafId: this.categoryId,
          };
          if(_formdata.basePlateType == 0){
            _formdata.isBasePlate = 0
          }
          delete _formdata.basePlateType
          // 定制商品工艺类型处理
          _formdata.customizedTechnology.twiceType = _formdata.customizedTechnology.technologyType == 1 ? [_formdata.customizedTechnology.twiceType] : _formdata.customizedTechnology.multipleTwiceType;
          delete _formdata.customizedTechnology.multipleTwiceType; // 删除前端使用的字段
          // 商品产地
          let pFileList = (_formdata?.productWhExtAttrVo?.productOriginCertFiles || []).filter(i => i.fileUrl)
          if(pFileList.length === 0){ // 不存在证明文件 productOriginCertFiles 置为null
            _formdata.productWhExtAttrVo.productOriginCertFiles = null
          }
          //尺码表
          if (this.$refs.sizeChartRef) {
              _formdata.sizeTemplate = await this.$refs.sizeChartRef.method_getSizeData();
          }
          _formdata.goodsLayerDecoration = _formdata.goodsLayerDecoration.map((imgUrl, index) => {
            return {
              lang: 'en',
              imgUrl,
              ...widthAndHeight[index],
            };
          });
          _formdata.productGuideFile = _formdata.productGuideFile.map(pg => {
            return {
              fileName: pg.name,
              url: pg.url,
              language: pg.language,
              shopIdPdfIdMap: pg.shopIdPdfIdMap || null,
            };
          });
          _formdata.productOuterPackageInfoVo.productOuterPackageImages = _formdata.productOuterPackageInfoVo.productOuterPackageImages.map(
            imageUrl => ({ imageUrl })
          );
          // 模特信息
          if(this.modelData.enabled && this.$refs.modelInfoRef){
            let goodsModelVo = this.$refs.modelInfoRef.getData();
            _formdata.goodsModelVo = goodsModelVo
          }
          _formdata.shopBrandConf = this.mergeHiddenShopData(cloneDeep(_formdata.shopBrandConf), this.originalShopBrandConf, this.shopList);
          console.log(cloneDeep(_formdata), '----_formdata---');
          // resolve(false);
          // return;
          resolve(_formdata);
        });
      });
    },
    // 翻译
    translateData(fields=[],translateFn){
      let params = {}
      fields.forEach(field => {
        if(field === 'spec'){
          params[field] = this.specifications
        }else{
          params[field] = this.self_form[field]
        }
      });
      translateFn(params,{
        shopId:this.shopId,
        leafCategoryId:this.categoryId
      }).then(res => {
        if(res){
          for(let k in res){
            if(k === 'spec'){
              this.specifications = res[k]
            }else{
              this.self_form[k] = res[k]
            }
          }
        }
      });
    },
    formatSpecifications(specifications) {
      let newSpecifications = cloneDeep(specifications).map((item, index) => {
        let opts = null;
        if(item.isSale) {
          opts = this.salePropList.find(s => s.refPid === item.refPid)?.values
        }
        item.values.map(v => {
          v.extendValues.parentSpecId = item.extendValues.parentSpecId;
          if(opts?.length) {  
            const findOptItem = opts.find(o => o.vid === v.vid) || ''
            v.extendValues.specId = findOptItem.specId || '';
          } else {
            v.extendValues.specId = '';
          }
          if (item?.extendValues?.isSkc) {
            const product_skc = {
              ...v.extendValues.product_skc,
              mainProductSkuSpecReqs: [
                {
                  parentSpecId: item.extendValues.parentSpecId,
                  parentSpecName: item.name,
                  specId: v.extendValues.specId || '',
                  specName: v.value,
                },
              ],
              skcSpecId: v.extendValues.specId || '',
            };
            v.extendValues.product_skc = product_skc;
          } else {
            delete v.extendValues.product_skc;
          }
          if (!item.showImg) {
            delete v.imageUrl;
          }
        });
        ['isSale', 'allowCreate', 'canNote', 'showImg', 'required'].forEach(key => {
          delete item[key];
        });
        return item;
      });
      return newSpecifications;
    },
    useGroupImages(data, type) {
      const { mainImages = [], images = [], speImages = [] } = data;
      let pic = [],
        description = [];
      if (type === 'add') {
        pic = [...this.self_form.images].filter(Boolean);
        description = [...this.self_form.descInfo];
      }
      if (mainImages.length) {
        this.self_form.images = [...pic, ...mainImages].filter(Boolean).slice(0, 9);
      }
      if (images.length) {
        this.self_form.descInfo = [...description, ...images].filter(Boolean).slice(0, 20);
      }
      const firstSpec = this.specifications[0];
      if (firstSpec && firstSpec.values && speImages.length) {
        firstSpec.values.forEach(specValue => {
          // 如果是新增模式且已有图片，则跳过
          if (type === 'add' && specself_form.imageUrl) {
            return;
          }

          // 查找匹配的图片
          const matchedImage = speImages.find(img => img.name === specself_form.value);
          if (matchedImage) {
            specself_form.imageUrl = matchedImage.imgUrl;
          }
        });
      }
    },
    getGroupImagesList(list) {
      this.showGroupImages = !!list?.length;
    },
    editGroupImages() {
      this.changeToBase('openGroupImgs');
    },
    // 获取配置
    async getConf() {
      const res = await getCrossborderConfig({ platform: this.platform });
      if(res){
        const { customizedTechnologyVo,autoCropImageConfigList} = res;
        // let _customizedTechnologyVo = {
        //   ...customizedTechnologyVo
        // }
        // if(_customizedTechnologyVo.technologyType){
        //   if(_customizedTechnologyVo.technologyType == 2){
        //       _customizedTechnologyVo.multipleTwiceType = _customizedTechnologyVo.twiceType || []
        //       _customizedTechnologyVo.twiceType = ''
        //   }else{
        //       _customizedTechnologyVo.twiceType = _customizedTechnologyVo.twiceType ? _customizedTechnologyVo.twiceType[0] : ''
        //   }
        //   this.self_form.customizedTechnology = merge(this.self_form.customizedTechnology,_customizedTechnologyVo)
        // }
        this.autoCropImageConfigList = autoCropImageConfigList || []
      }
    },

    async getMeta() {
      const res = await getSizechartsMeta({ shopId: this.shopId, catId: this.categoryId });
      this.sizeElementList = (res?.sizeSpecMeta?.elementList || []).map(item => {
        item.id = String(item.id);
        return item;
      });
      this.sizeGroupList = res?.sizeSpecMeta?.groupList || []
    },
    // 查询类目是否支持添加模特
    getModelInfo(){
      let params = {
        shopId:this.shopId,
        catId:this.categoryId
      }
      getModelCats(params).then(res => {
        if(res){
          this.modelData = res
        }
      })
    },
    firstLetter(str){
      let title = capitalizeFirstLetter(str)
      this.self_form.productEnName = title
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.platform-info-edit-wrp {
  .product-origin-upload-btn{
    display: flex;
    align-items: center;
    ::v-deep .el-upload-list .el-upload-list__item{
        margin-top: 0px;
        font-size: 12px;
    }
  }
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
  .tips{
    font-size: 12px;
    color: #909399;
  }
  ::v-deep .el-tabs__header{
    margin-bottom: 1px;
  }
  ::v-deep .el-tabs__item{
      height: 32px !important;
      line-height: 32px !important;
  }
}
</style>